import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { Divider, Grid, Select, MenuItem, FormControl, InputLabel, TextField, Button } from '@material-ui/core'
import { API, RISKMGT } from '@const'
import * as utils from '@utils'
import { AddPlayerRoleDialog, EditRiskRuleBigRichDialog } from '@risk'
import ConfirmMsgDialog from '@msg/confirm-msg-dialog'
import RefreshButton from '@miscs/refresh-button'
import PfSubPfSelect from '@select/pf-sub-pf-select'
import Table from '@tables/table'

class PlayerRoleListPage extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'PlayerRoleListPage')
        }
    }
    state = {
        compDidMount: false,
        riskRole: RISKMGT.RISK_ROLE_BIG_RICH,
        riskRuleLsit: {},
        columns: [],
    }

    actions = [
        {
            text: 'add',
            icon: 'add',
            isFreeAction: true,
            onClick: (_evt, _data) => {
                this.addDialog.OpenDialog({ riskRole: this.state.riskRole })
            },
        },
    ]
    deleteColumn = {
        field: 'delete',
        render: (rowData) => {
            return (
                <Button
                    style={{ minWidth: '93px' }}
                    variant="contained"
                    color="primary"
                    onClick={() => {
                        this.confirmDialog.OpenDialog({
                            type: 'info',
                            msg: this.t('removeRoleConfirm', {
                                player_name: rowData['player_name'],
                                risk_role: this.state.riskRole,
                            }),
                            confirm: (_params) => {
                                this.confirmDialog.SetConfirmBtnDisabled(true)

                                utils.apiRequest(
                                    'patch',
                                    API.RISKMGT_PLAYER_RISK_INFO,
                                    {
                                        pf_account_list: [rowData['pf_account']],
                                        risk_role: RISKMGT.RISK_ROLE_DEFAULT,
                                    },
                                    (_data) => {
                                        this.queryData()
                                        this.confirmDialog.closeDialog()
                                    },
                                    (_err) => {
                                        this.confirmDialog.SetConfirmBtnDisabled(false)
                                    }
                                )
                            },
                        })
                    }}>
                    {this.t('delete')}
                </Button>
            )
        },
    }
    columnsTemplate = {
        [RISKMGT.RISK_ROLE_BIG_RICH]: [
            {
                field: 'pf_sub_pf_id',
                type: 'platform',
            },
            {
                field: 'pf_account',
            },
            {
                field: 'player_name',
            },
            {
                field: 'accumulated_rounds',
            },
            { field: 'accumulated_prize', type: 'currency' },
            {
                field: 'rtp_value',
                type: 'percentage',
            },
            {
                field: 'accumulated_bet',
                type: 'currency',
            },
            { field: 'expired_at', type: 'datetime' },
            this.deleteColumn,
        ],
        [RISKMGT.RISK_ROLE_BLACKLIST]: [
            {
                field: 'pf_sub_pf_id',
                type: 'platform',
            },
            {
                field: 'pf_account',
            },
            {
                field: 'player_name',
            },
            {
                field: 'accumulated_rounds',
            },
            { field: 'accumulated_prize', type: 'currency' },
            {
                field: 'rtp_value',
                type: 'percentage',
            },
            {
                field: 'accumulated_bet',
                type: 'currency',
            },
            this.deleteColumn,
        ],
    }

    componentDidMount() {
        this.setState({
            compDidMount: true,
            columns: this.columnsTemplate[this.state.riskRole],
        })
    }

    getValue(risk_label, key, idx) {
        const rule = this.state.riskRuleLsit[utils.ComposeRiskRuleKey(risk_label, this.pfSelect.state.pfSubPfId)]

        return rule ? (idx !== undefined ? rule[key][idx] : rule[key]) : ''
    }

    queryData = () => {
        this.table.SetLoading(true)

        if (this.pfSelect.state.pfSubPfId !== 'all' && this.state.riskRole === RISKMGT.RISK_ROLE_BIG_RICH) {
            utils.apiRequest(
                'get',
                API.RISKMGT_RISK_RULE_LIST,
                {
                    risk_label_list: RISKMGT.RISK_ROLE_BIG_RICH,
                    pf_sub_pf_id: this.pfSelect.state.pfSubPfId !== 'all' ? this.pfSelect.state.pfSubPfId : '',
                },
                (data) => {
                    if (data)
                        this.setState(
                            {
                                riskRuleLsit: data,
                            },
                            this.queryTableData()
                        )
                },
                () => {
                    this.table.SetData([])
                },
                true
            )
        } else {
            this.queryTableData()
        }
    }

    queryTableData = () => {
        utils.apiRequest(
            'get',
            API.RISKMGT_PLAYER_RISK_INFO_LIST,
            {
                pf_id: this.pfSelect.state.pfId !== 'all' ? this.pfSelect.state.pfId : '',
                pf_sub_pf_id: this.pfSelect.state.pfSubPfId !== 'all' ? this.pfSelect.state.pfSubPfId : '',
                risk_role: this.state.riskRole,
            },
            (data) => {
                const tempList = []
                for (const idx in data) {
                    var temp = utils.deepCopy(data[idx])

                    tempList.push(temp)
                }

                this.table.SetData(tempList)
            },
            (_err) => {
                this.table.SetData([])
            },
            true
        )
    }

    render() {
        return (
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <PfSubPfSelect
                        onRef={(ref) => (this.pfSelect = ref)}
                        options={{
                            subPfChangeCallback: () => {
                                this.queryData()
                                this.setState({}) // this.pfSelect.state not trigger page refresh
                            },
                            hideCurrency: true,
                            hideAllSubPlatform: true,
                        }}></PfSubPfSelect>
                    <FormControl className={this.props.classes.formControl}>
                        <InputLabel htmlFor="age-simple">{this.t('role')}</InputLabel>
                        <Select
                            value={this.state.riskRole}
                            onChange={(event) => {
                                this.setState(
                                    {
                                        riskRole: event.target.value,
                                        columns: this.columnsTemplate[event.target.value],
                                    },
                                    () => this.queryData()
                                )
                            }}>
                            <MenuItem value={RISKMGT.RISK_ROLE_BIG_RICH}>{this.t('RiskRole.' + RISKMGT.RISK_ROLE_BIG_RICH)}</MenuItem>
                            <MenuItem value={RISKMGT.RISK_ROLE_BLACKLIST}>{this.t('RiskRole.' + RISKMGT.RISK_ROLE_BLACKLIST)}</MenuItem>
                        </Select>
                    </FormControl>
                    <RefreshButton style={{ marginLeft: '50%' }} callback={() => this.queryData()}></RefreshButton>
                </Grid>
                {this.state.compDidMount && this.state.riskRole === RISKMGT.RISK_ROLE_BIG_RICH && this.pfSelect.state.pfSubPfId !== 'all' && (
                    <React.Fragment>
                        <Grid item>{this.t('bigRichRule')}</Grid>
                        <Grid item xs={1}>
                            <TextField
                                InputProps={{ readOnly: true }}
                                label={this.t('accumulatedDays')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={this.getValue(RISKMGT.RISK_ROLE_BIG_RICH, 'accumulated_days')}
                                margin="dense"
                                fullWidth
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <TextField
                                InputProps={{ readOnly: true }}
                                label={this.t('betRankAbove')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={this.getValue(RISKMGT.RISK_ROLE_BIG_RICH, 'bet_rank_boundary', 1) + '%'}
                                margin="dense"
                                fullWidth
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={1}>
                            <TextField
                                InputProps={{ readOnly: true }}
                                label={this.t('expiredDays')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={this.getValue(RISKMGT.RISK_ROLE_BIG_RICH, 'expired_days')}
                                margin="dense"
                                fullWidth
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <Button
                                variant="contained"
                                onClick={() => {
                                    this.editRiskRuleBigRichDialog.OpenDialog({
                                        riskRuleLsit: this.state.riskRuleLsit,
                                        pfSubPfId: this.pfSelect.state.pfSubPfId,
                                    })
                                }}
                                color="primary">
                                {this.t('bigRichRuleSetting')}
                            </Button>
                        </Grid>
                        <Grid item xs={5}></Grid>
                        <Grid item xs={8}>
                            {this.t('bigRichRuleMsg1')}
                        </Grid>
                    </React.Fragment>
                )}
                <Grid item xs={12}>
                    <Divider />
                </Grid>
                <Grid item xs={12}>
                    {this.state.compDidMount && (
                        <Table
                            ownerName="PlayerRoleListPage"
                            columns={this.state.columns}
                            options={{ export: true, orderIdx: 1 }}
                            onRef={(ref) => (this.table = ref)}
                            actions={this.actions}
                        />
                    )}
                    <AddPlayerRoleDialog
                        onRef={(ref) => (this.addDialog = ref)}
                        confirmCallback={() => {
                            this.queryData()
                        }}
                    />
                    <ConfirmMsgDialog onRef={(ref) => (this.confirmDialog = ref)} />
                </Grid>
                <EditRiskRuleBigRichDialog
                    onRef={(ref) => (this.editRiskRuleBigRichDialog = ref)}
                    confirmCallback={() => {
                        this.queryData()
                    }}></EditRiskRuleBigRichDialog>
            </Grid>
        )
    }
}

const styles = (theme) => {
    return {
        formControl: {
            margin: theme.spacing(1),
            width: '150px',
        },
        button: {
            margin: theme.spacing(1),
        },
        rightIcon: {
            marginRight: theme.spacing(1),
        },
    }
}

PlayerRoleListPage.propTypes = {
    classes: PropTypes.object.isRequired,
    dataService: PropTypes.object,
}

export default hoc(styles)(PlayerRoleListPage)
